import { render, staticRenderFns } from "./CarForm.vue?vue&type=template&id=07024174&scoped=true&"
import script from "./CarForm.vue?vue&type=script&lang=js&"
export * from "./CarForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07024174",
  null
  
)

export default component.exports